var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconNavigationExpandLess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.912l-5 5 1.175 1.175L10 9.271l3.825 3.816L15 11.912z",
    fill: "#2C3032",
    fillRule: "evenodd",
    fillOpacity: 0.6
  })));
}

export default __webpack_public_path__ + "3342014ce16e798f527345e4ed563e3d.svg";
export { SvgIconNavigationExpandLess as ReactComponent };